import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionProps, selectState } from '../../utils/reduxActions';
import { loginActions } from './reducer';

interface LoginProps {
  actions?: any;
  controls?: any;
  history?: any;
}

const ChangesPolicy: React.FC<LoginProps> = props => {
  return (
    <>
      <div className='h-screen min-h-screen max-h-screen flex flex-col justify-center items-center p-4 w-full'>
        <h1 className='text-2xl font-bold mb-6'>
          Inabit - Política de Cambios y Devoluciones
        </h1>
        <iframe
          src='https://drive.google.com/file/d/1XSsF_4mSvawtwrqwKeoeLxAA7pZB8QlU/preview'
          className='w-3/4 h-full border-0'
          allow='autoplay'
          title='Inabit documento de política de cambios y devoluciones'
        />
      </div>
    </>
  );
};

const withConnect = connect(
  selectState('login.controls'),
  actionProps({ ...loginActions }),
);

export default withRouter(withConnect(ChangesPolicy));
